import axios from './axios'
const util = require('util')


export default {
    codeLogin:function(phone,code,roleType,openid){
        var api = "/public/codeLogin";
        return axios.post(api,{phone:phone,code:code,roleType:roleType,openid})
        
        .then(res=> {
            var token = res.headers["TOKEN"];
            axios.defaults.headers["TOKEN"] = token;
            if(res.data.status==0){
                localStorage.setItem("userId",res.data.data.userId);
            }
            return res.data});
    },
    sendSms:function(phone){
        var api = util.format("/public/send/%s",phone)
        return axios.get(api).then(res=> {
            return res.data})
    },
    wechatJssdk(url){
        var url = url && location.href
        var api = `/mp/jssdk?url=${url}`;
        return axios.get(api).then(res=> {
            return res.data})
    },
    wechatLogin:function(openid){
        var api = "/public/wechatLogin";
        return axios.post(api,{openid:openid})        
        .then(res=> {
            var token = res.headers["TOKEN"];

            axios.defaults.headers["TOKEN"] = token;
            if(res.data.status==0){

                localStorage.setItem("userId",res.data.data.userId);
            }

            return res.data});
    },
} 






// WEBPACK FOOTER //
// ./src/api/public.js